import { Component, OnInit } from '@angular/core';
import { Poll } from '../_models/poll';
import { Router, ActivatedRoute } from '@angular/router';
import { ConferenceService } from '@conference/conference-info/_services/conference.service';
import { Element } from '@conference/conference-info/_models/element';
import { PollsService } from '@conference/polls/_services/polls.service';
import * as  ClassicEditor  from 'assets/ckeditor/ckeditor.js';

@Component({
  selector: 'app-polls-edit',
  templateUrl: './polls-edit.component.html',
  styleUrls: ['./polls-edit.component.css']
})
export class PollsEditComponent implements OnInit {

  public model: Poll = new Poll();
  public programElements: Element[];
  public Editor = ClassicEditor;
  page:any;
  pageSize:any;
  htmlEditorConfig = {
    mediaEmbed: {
      previewsInData: true
    },
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'indent',
        'outdent',
        '|',
        'blockQuote',
        'insertTable',
        'undo',
        'redo'
      ]
    }
  };

  ngOnInit(): void {

    var id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.pollsService.get(id).subscribe(result => {
      this.model = result;
    }, error => {
      this.router.navigate(['conference/polls-list'],{state:{page:this.page,pageSize:this.pageSize}});
    });


    this.conferenceService.getProgramElements().subscribe(result => {
      this.programElements = result.elements;
    });
  }

  onSubmit() {
    this.pollsService.edit(this.model).subscribe(result => {
      this.router.navigate(['conference/polls-list'],{state:{page:this.page,pageSize:this.pageSize}});
    })
  }

  questionAdded(event: any) {
  }

  questionDeleted(event: any) {
    var indexToDelete = this.model.questions.indexOf(event);
    this.model.questions.splice(indexToDelete, 1);
  }

  constructor(private pollsService: PollsService,
    private router: Router,
    private route: ActivatedRoute,
    private conferenceService: ConferenceService) {
      if (this.router.getCurrentNavigation().extras.state){
        this.page = this.router.getCurrentNavigation().extras.state.page;
        this.pageSize = this.router.getCurrentNavigation().extras.state.pageSize;
      }
    }

}
